function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M0,7a7,7,0,1,1,7,7A7,7,0,0,1,0,7Z",
  fill: "#cad1d9"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(5 4)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  width: 1.055,
  height: 1.055,
  transform: "translate(1.583 5.286)",
  fill: "#396288"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M4.163,1.619A2.11,2.11,0,0,0,0,2.121H1.055a1.059,1.059,0,0,1,2.11.179,1.1,1.1,0,0,1-1.113.876.47.47,0,0,0-.47.47h0V4.759H2.638v-.6A2.11,2.11,0,0,0,4.163,1.619Z",
  transform: "translate(0 0)",
  fill: "#396288"
}));

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "question",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.991,
    height: 13.991,
    viewBox: "0 0 13.991 13.991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/questionMark.26e03116.svg";
export { ForwardRef as ReactComponent };